import { render, staticRenderFns } from "./FailureTypeDialog.vue?vue&type=template&id=534a8ae7"
import script from "./FailureTypeDialog.vue?vue&type=script&lang=ts"
export * from "./FailureTypeDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports